export var oGoldenPrize = InheritO(CPlants, {
	EName: "oGoldenPrize",
	CName: "Golden Trophy",
	PicArr: ["images/interface/0.gif", "images/interface/0.gif"],
	Tooltip: "You win!",
});
